import type { ReactNode } from "react";
import { Typography } from "@mui/material";

interface InlineErrorChipProps {
  text?: string;
}

function InlineErrorChip({ text = "ERREUR" }: Readonly<InlineErrorChipProps>): ReactNode {
  return (
    <Typography
      variant="body2"
      component="span"
      sx={{
        color: "error.main",
        backgroundColor: "error.light",
        paddingX: 1,
        paddingY: 0.5,
        fontWeight: 600,
        borderRadius: 1,
        display: "inline-block",
      }}>
      {text}
    </Typography>
  );
}

export default InlineErrorChip;
